// @ts-nocheck
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";

export default function DataList({ huobigetHistory }) {
  console.log(huobigetHistory);
  
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  
  const getArray1 = () => {
    const nodes = [];
    for (const i in huobigetHistory) {
      const data = huobigetHistory[i]?.data[0];
      if (i > 9) {
        break;
      }
      nodes.push(
        <div
          key={`buy-${i}`}
          className="flex justify-between py-1 px-2 text-sm border-b border-neutral-700  md:flex-row flex-row-reverse"
        >
          <div className="flex-1 text-right">
            <span className="text-green-500">{data.amount?.toFixed(5)}</span>
          </div>
          <div className="flex-1 text-left md:text-right">
            <span className="text-neutral-200">{data.price}</span>
          </div>
        </div>
      );
    }
    return nodes;
  };

  const getArray2 = () => {
    const nodes = [];
    for (const i in huobigetHistory) {
      const data = huobigetHistory[i]?.data[0];
      if (i <= 9) {
        continue;
      }
      nodes.push(
        <div key={`sell-${i}`} className="flex justify-between py-1 px-2 text-sm border-b border-neutral-700">
          <div className="flex-1 text-left">
            <span className="text-neutral-200">{data.price}</span>
          </div>
          <div className="flex-1 text-right">
            <span className="text-red-500">{data.amount?.toFixed(5)}</span>
          </div>
        </div>
      );
    }
    return nodes;
  };
  
  return (
    <div className="flex flex-col md:flex-row justify-between md:p-2 pl-2">
      <div className="w-full pr-1">
        <div className="md:rounded-lg overflow-hidden md:bg-neutral-700/30">
          <div className="flex md:flex-row flex-row-reverse font-bold justify-between md:bg-neutral-700 py-2 px-2 text-xs text-neutral-400">
            <div className="flex-1 text-right">
              <span>{translate(getText("數量"))}</span>
            </div>
            <div className="flex-1 text-left md:text-right">
              <span>{translate(getText("價格"))}</span>
            </div>
          </div>
          <div className="max-h-[200px] overflow-y-auto">
            {getArray1()}
          </div>
        </div>
      </div>
      <div className="w-full pl-1">
        <div className="md:rounded-lg overflow-hidden md:bg-neutral-700/30">
          <div className="flex justify-between font-bold md:bg-neutral-700 py-2 px-2 text-xs text-neutral-400">
            <div className="flex-1 text-left">
              <span>{translate(getText("價格"))}</span>
            </div>
            <div className="flex-1 text-right">
              <span>{translate(getText("數量"))}</span>
            </div>
          </div>
          <div className="max-h-[200px] overflow-y-auto">
            {getArray2()}
          </div>
        </div>
      </div>
    </div>
  );
}
